var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBirdCarryingBook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 93,
  height: 120,
  viewBox: "0 0 93 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 73.503c4.429-5.936 17.64-16.508 36.183-11.307 9.95-12.438 26.006-11.025 32.79-8.48L91.5 92.36c-6.784-2.544-22.84-4.523-32.79 7.915-18.545-5.202-32.038 5.371-36.466 11.307L5 73.503Z",
  fill: "#FBF6F0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.183 62.196C22.639 56.995 9.429 67.566 5 73.503l17.244 38.08c4.428-5.936 17.921-16.509 36.465-11.307m-17.526-38.08c9.95-12.438 26.006-11.025 32.79-8.48L91.5 92.36c-6.784-2.544-22.84-4.523-32.79 7.915m-17.527-38.08 17.526 38.08",
  stroke: "#C7A77B"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M91.5 91.03v7.47c-5.935-2.226-21.331-3.333-31 4M5 73.786l.835 7.134L23.08 119c3.92-5.254 19.43-16.588 34.921-15.5",
  stroke: "#C7A77B"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M54 105c3.397 3.435 10.742 2 10.742-4.417",
  stroke: "#C7A77B"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m30.778 60.672 7.694-11.158 12.941 5.23",
  stroke: "#D6BB96"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.937 51.605c15.218 0 33.433-11.805 25.507-31.858l3.314-4.69-4.035 3.558 2.45-6.954-4.179 4.69c-2.017-2.264-7.666-6.048-14.122-3.073-4.033 2.324-5.84 7.052-6.855 9.709-.327.856-.572 1.497-.783 1.773-.104.137-.259.395-.468.745-1.53 2.557-6.003 10.032-15.384 11.06-5.364 0-9.078-3.88-10.52-5.498 2.018 6.846 9.857 20.538 25.075 20.538Zm19.31-35.902-3.315 4.528c-.048-.755.173-2.458.865-3.234.692-.776 1.873-1.186 2.45-1.294Z",
  fill: "#D6BB96"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.007 23.019c-3.685-4.16-6.429-9.178-6.989-14.857 4.955 5.862 14.93 12.069 24.85 10.467 0 0-2.208 3.463-1.762 9.41.302 4.01 3.818 6.696 5.147 7.574.317.2.506.314.506.314-17.335 1.31-26.206-4.846-31.277-19.618 3.713 3.147 6.799 5.302 9.525 6.71Z",
  fill: "#D6BB96"
})));
export default SvgBirdCarryingBook;